// src/components/Layout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Breadcrumbs from '../components/Breadcrumbs'
const Layout = () => {
    return (
        <div className="admin-layout">
            <Navbar />
            <div className="main-container ace-save-state" id="main-container">
                <Sidebar />
                <div className="main-content">
                    <div className="main-content-inner">
                        <Breadcrumbs />
                        <div className="page-content">
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Layout;
